<template>
    <div class="home" >
      <!-- 头部 -->
      <div class="title" >
        <img src="../../public/@2x/logo.png" alt="" class="logo">
        <img src="../../public/@2x/title.png" alt="" class="tit">
      </div>
  
      <!-- 表单 -->
      <table>
        <tr class="tab-title">
          <td style="text-align: left; padding-left: 40px;">活动场地</td>
          <td style="text-align: center;">活动名称</td>
          <td style="text-align: right; padding-right: 40px;">活动时间</td>
        </tr>
  
        <tr class="tab-main" v-for="(item,index) in list" :key="index">
          <td style="text-align: left; padding-left: 40px;">{{item.area_name}}</td>
          <td style="text-align: center;">{{item.name}}</td>
          <td style="text-align: right; padding-right: 40px;">
            <span>{{item.date}}</span>
            <span class="time" :class="[{ 'c1': item.time ==  time.i1},{ 'c2': item.time ==  time.i2},{ 'c3': item.time ==  time.i3}]">{{(item.time)}}</span>
          </td>
        </tr>
      </table>
  
    </div>
  </template>
  
  <script>
  import { getlistdata } from '../api/index'
  export default {
    name: 'HomeView',
    data() {
      return {
        time:{
          i1 :'全天',
          i2 :'下午',
          i3 :'上午'
        },
        list: [],
        post: {
          page: 1,
          limit: 12,
          count: 0
        }
      }
    },
    created() {
      this.getlist()
      setInterval(()=>{
        this.getlist()
      },10000)
    },
    methods: {
      async getlist() {
        let { data: res } = await getlistdata(this.post)
        this.post.count = res.count
        if(this.post.page*this.post.limit>= this.post.count){
          this.post.page = 0
        }else{
          this.post.page = this.post.page+1
        }
        this.list = res.list
      },
    },
  }
  </script>
  
  
  <style lang="less">
  .time {
    width: 60px;
    height: 32px;
    border-radius: 3px;
    color: #fff;
    margin-left: 20px;
    padding: 4px 8px;

    background-color: #7697BF;
  }
  
  .c1 {
    background-color: #1A5194;
  }
  
  .c2 {
  }
  
  .c3 {
    background-color: #1A5194;
  }
  
  table {
    min-width: 750px;
    width: 100%;
  
    .tab-title {
      padding: 0 40px;
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      font-weight: bold;
      color: #2B4F7A;
    }
  
    .tab-main {
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      color: #2B4F7A;
      font-size: 16px;
    }
  
    td {
      width: 33.3%;
    }
  }
  
  tr:nth-child(odd) {
    background-color: #F1F7FF;
  }
  
  .title {
    min-width: 750px;
    text-align: center;
    width: 100%;
    height: 80px;
    background: #134B90;
  
  
    .logo {
      float: left;
      margin-top: 20px;
      padding-left: 40px;
    }
  
    .tit {
      margin-top: 24px;
      margin-right: 220px;
    }
  }
  </style>
  